import "./styles.scss";

import { useTranslation } from "react-i18next";
import classnames from "classnames";

import { ReactComponent as CheckmarkIcon } from "assets/icons/validator-checkmark.svg";

const mainClass = "password-validator";

const PasswordValidator = ({ password, variant, hasProgress }) => {
  const { t } = useTranslation();

  const validator_data = [
    {
      label: t("At least 10 characters"),
      status: password.length >= 10,
    },
    {
      label: t("One number"),
      status: /[0-9]/.test(password),
    },
    {
      label: t("One upper case letter"),
      status: /[A-Z]/.test(password),
    },
    {
      label: t("One lower case letter"),
      status: /[a-z]/.test(password),
    },
  ];

  const validLength = validator_data.filter((item) => item.status).length;

  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--${variant}`]: !!variant,
      })}
    >
      {hasProgress && (
        <div className={`${mainClass}__progress`}>
          {new Array(4).fill().map((_, index) => (
            <div
              key={index}
              className={classnames(`${mainClass}__progress-item`, {
                [`${mainClass}__progress-item--success`]:
                  index <= validLength - 1,
              })}
            />
          ))}
        </div>
      )}
      {validator_data?.map(({ label, status }, index) => (
        <div
          key={index}
          className={classnames(`${mainClass}__item`, [
            `${mainClass}__item--${!!status ? "success" : "failed"}`,
          ])}
        >
          <i>{variant === "checkmarks" && <CheckmarkIcon />}</i>
          <span>{label}</span>
        </div>
      ))}
    </div>
  );
};

export default PasswordValidator;
